import { render, staticRenderFns } from "./ProductTypeList.vue?vue&type=template&id=3824c446&"
import script from "./ProductTypeList.vue?vue&type=script&lang=js&"
export * from "./ProductTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports